import { useEffect, useState } from "react";
import { useAuth } from "../../hooks/useAuth";
import DashboardSidebar, { SidebarToggle } from "./DashboardSidebar";
import OnboardingMain from "../onboarding/OnboardingMain";

const obKey = "kaizu_fullSelf_ob";

export default function Dashboard({ children }: { children: React.ReactNode }) {
  const { isFulltimeSelfUser } = useAuth();
  const [shouldSeeOb, setShouldSeeOb] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const isObCompletedBefore = localStorage.getItem(obKey);
    if (isObCompletedBefore !== "true" && isFulltimeSelfUser) {
      setShouldSeeOb(true);
    }
  }, [isFulltimeSelfUser]);

  if (shouldSeeOb) {
    return <OnboardingMain onComplete={setShouldSeeOb} />;
  }

  return (
    <div className="flex min-h-screen">
      <DashboardSidebar
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />

      <main className="flex-1 lg:ml-56 min-w-0">
        <SidebarToggle onClick={() => setSidebarOpen(true)} />
        <div className="max-w-5xl mx-auto px-4 sm:px-6 pt-4 lg:pt-8 pb-20 md:pb-24">
          {children}
        </div>
      </main>
    </div>
  );
}
